

import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {DangerButton} from 'Components/Button';

import {translation} from 'Services/TranslationHelpers';
import StandaloneChat from "Components/Networking/StandaloneChat";
import PrimaryButton from "Components/Button/PrimaryButton";
import Link from "Components/Utilities/Link";
import DarkButton from "Components/Button/DarkButton";
import { asset } from "Services/BaseHelpers";

export default class StandAloneChatModel extends React.Component {
    /**
     * @var state
     */
    state = {
    };

    UserAvatar( user ) {
        if ( user.avatar_path && user.avatar_path.url ) {
            return <img
                src={ user.avatar_path.url }
                alt={ user.name }
                className="md:w-64 h-auto w-full md:h-64 object-cover  mx-auto flex items-center justify-center "
            />;
        } else {
            return <img
                src={ asset( '/images/placeholder-profile.png' ) }
                alt={ user.name }
                className="md:w-64 h-auto w-full md:h-64 object-cover  mx-auto flex items-center justify-center "
            />;
        }
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {onClose, user} = this.props;

        return (
            <Modal titleClass="text-app-blue" onClose={onClose} className="bg-app-orange max-w-screen-sm md:max-w-4xl">
                <ModalHeader onClose={onClose} className="border-none" titleClassName="text-app-blue" />
                <ModalBody>
                    <div className="flex flex-col md:flex-row items-center justify-center  gap-5">
                        <div className="">
                            {/*{ this.UserAvatar ( user ) }*/}
                            <h2 className="text-xl mt-2 font-bold uppercase text-app-blue text-center">{ user.name }</h2>
                        </div>
                        <div className="text-left self-center space-y-4">
                           { user.job_title && (
                               <h2 className="text-lg text-app-blue">Job Title: { user.job_title }</h2>
                            )}

                            { user.company_name && (
                                <h2 className="text-lg text-app-blue">Company: { user.company_name }</h2>
                            )}

                            { user.email && (
                                <h2 className="text-lg text-app-blue">
                                    Email: <a href={"mailto:" + user.email} className={"cursor-pointer underline"}> { user.email }</a>
                                </h2>
                            )}

                            { user.linkedin && (
                                <h2 className="text-lg text-app-blue">
                                    LinkedIn: <a href={ user.linkedin } className={"cursor-pointer underline"} target={"_blank"}>
                                        View LinkedIn Profile
                                    </a>
                                </h2>
                            )}

                            <h2 className="text-lg text-app-blue">
                                Attending: <span className={"font-bold"}>
                                    { user.group_name.toLowerCase ().includes ( 'virtual' ) ? 'Virtually' : 'In person' }
                            </span>
                            </h2>
                        </div>
                        <div className="flex flex-col self-end h-full mx-auto">
                            <a
                                href={ "/networking/" + user.id }
                                className="text-app-green"
                                onClick={ onClose }
                            >
                                <DarkButton text={ "Connect" } />
                            </a>
                            <DarkButton
                                text={ translation ( 'misc', 'close' ) }
                                onClick={ onClose }
                                className="bg-white text-app-blue hover:bg-app-blue hover:text-white hover:border hover:border-app-blue mt-2"
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}
